<template>
  <div class="content">
    <a-row>
      <a-col>
        <download-excel
          style="width: 100px"
          :data="data"
          :fields="json_fields"
          type="xls"
          name="砍价订单图表.xls"
        >
          <a-button class="buttonExport" type="primary">Excel导出</a-button>
        </download-excel>
        <a-modal
          centered
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input v-model="uidPhone" placeholder="请输入用户uid或手机号码" />
        </a-modal>
        <a-table
          :scroll="{ x: 2000, y: 500 }"
          :columns="columns"
          :row-key="(item) => item.uid"
          :data-source="data"
          :pagination="pagination"
          :loading="loading"
          @change="handleTableChange"
        >
          <template slot="pic" slot-scope="name">
            <img :src="name" alt="" />
          </template>

          <!-- <template slot="avatar">
        <a-avatar :src="avatar" icon="user" />
      </template> -->
          <!-- <template slot-scope="name">
      <span>{{name}}</span>
    </template> -->
          <!-- <a-switch slot="memberStatus" default-checked @change="onChange" /> -->
          <template slot="isMembers">
            <a-switch
              default-checked
              checked-children="正常"
              un-checked-children="关闭"
              @change="onChange"
            />
          </template>
          <template slot="operate" slot-scope="text, record">
            <a
              href=""
              v-on:click.prevent="
                topage(`/home/memberManagement/playRecord?id=${record.uid}`)
              "
              >游玩记录</a
            >
            <a
              href=""
              v-on:click.prevent="
                topage(`/home/memberManagement/userPullsNew?uid=${record.uid}`)
              "
              >用户拉新</a
            >
            <a @click="bind(record)">绑定上级</a>
          </template>
        </a-table></a-col
      >
    </a-row>
  </div>
</template>
<script>
import { exportList, queryMembersData } from "@/api/Members.js";
import { userBindSuperior } from "@/api/homeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "编号",

    dataIndex: "objId",
    width: 100,
    scopedSlots: { customRender: "objId" },
    align: "center",
  },
  {
    title: "用户uid",
    dataIndex: "uid",
    width: 100,
    scopedSlots: { customRender: "uid" },
    align: "center",
  },
  {
    title: "手机号码",
    dataIndex: "phone",

    width: 100,
    scopedSlots: { customRender: "phone" },
    align: "center",
  },
  {
    title: "头像",
    dataIndex: "headImg",
    width: 100,
    scopedSlots: { customRender: "pic" },
    align: "center",
  },
  {
    title: "昵称",
    dataIndex: "nickName",
    width: 100,
    scopedSlots: { customRender: "nickName" },
    align: "center",
  },
  {
    title: "会员状态",
    dataIndex: "isMembers",
    width: 100,
    scopedSlots: { customRender: "isMembers" },
    align: "center",
  },
  {
    title: "会员卡号",
    dataIndex: "areaId",
    width: 100,
    scopedSlots: { customRender: "areaId" },
    align: "center",
  },
  {
    title: "所属门店",
    dataIndex: "regionRecord",
    width: 150,
    scopedSlots: { customRender: "regionRecord" },
    align: "center",
  },
  {
    title: "生日",
    width: 150,
    scopedSlots: { customRender: "lastLogin" },
    align: "center",
  },
  {
    title: "性别",
    width: 100,
    scopedSlots: { customRender: "signShopRate" },
    align: "center",
  },
  {
    title: "年龄",
    width: 100,
    scopedSlots: { customRender: "signShopRate" },
    align: "center",
  },
  {
    title: "推荐码",
    dataIndex: "cityId",
    width: 100,
    scopedSlots: { customRender: "cityId" },
    align: "center",
  },
  {
    title: "注册时间",
    dataIndex: "lastLogin",
    width: 150,
    scopedSlots: { customRender: "lastLogin" },
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operate",
    width: 250,
    fixed: "right",
    scopedSlots: { customRender: "operate" },
    align: "center",
  },
];
export default {
  data() {
    return {
      uidPhone: "",
      data: [],
      objId: "",
      json_fields: {
        编号: "objId",
        用户id: "uid",
        手机号码: "phone",
        头像: "headImg",
        呢称: "nickName",
        会员状态: "usableStr",
        会员卡号: "areaId",
        所属门店: "regionRecord",
        生日: "lastLogin",
        性别: "signShopType",
        年龄: "signShopRate",
        注册时间: "createTime",
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      columnsMock: null,
      visible: false,
    };
  },
  props: ["formInline"],
  mounted() {
    // this.fetch();
    this.handleGetMembersList();
  },
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      exportList(10, this.pagination.current).then((res) => {
        this.data = res.data;
        console.log(res);
      });
      this.loading = false;
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
      // console.log(isMembers, '会员状态')
    },
    //
    bind(row) {
      this.objId = row.objId;
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
      userBindSuperior(this.uidPhone, this.objId).then((res) => {
        if (res.code === "0000") {
          this.handleGetMembersList();
          message.success(res.info);
        } else {
          message.warning(res.info);
        }
      });
    },
    // 获取会员管理列表数据
    handleGetMembersList() {
      exportList(10, 1).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    // 查询
    queryData() {
      this.loading = true;
      queryMembersData(10, 1, this.formInline.phone, this.formInline.uid).then(
        (res) => {
          console.log(res);
          this.loading = false;
          this.data = res.data;
          this.pagination.total = res.count;
        }
      );
    },

    // async handleGetMembersList(){
    //   let result =  await getMembersList()
    //   this.data = result.data.data
    //   console.log(result.data.data)
    // }
  },
};
</script>

<style lang="scss" scoped>
.buttonExport {
  margin: 10px 0;
}
img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.content {
  padding: 0 20px;
  margin-top: 20px;
  background-color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/memberManagement/memberManagementContent.vue